(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crosight-home-blog-posts"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('crosight-home-blog')) {
    customElements.define('crosight-home-blog', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.navigation = this.querySelector('[data-navigation]');
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.slider = this.dataset.slider === 'true';
        this.rtl = getComputedStyle(this.track).direction === 'rtl';
        this.suppressClick = false;
        this.previous?.addEventListener('click', () => this.move(-1), options);
        this.next?.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => this.scheduleUpdate(), { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (!this.slider || event.target !== this.track) return;
          let index;
          if (event.key === 'ArrowRight') index = this.currentIndex() + (this.rtl ? -1 : 1);
          if (event.key === 'ArrowLeft') index = this.currentIndex() + (this.rtl ? 1 : -1);
          if (event.key === 'Home') index = 0;
          if (event.key === 'End') index = this.track.children.length - 1;
          if (index === undefined) return;
          event.preventDefault();
          this.goTo(index);
        }, options);
        this.track.addEventListener('pointerdown', event => {
          if (!this.slider || this.dataset.overflow !== 'true' || event.pointerType !== 'mouse' || event.button !== 0) return;
          this.suppressClick = false;
          this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, left: this.track.scrollLeft, active: false };
        }, options);
        this.track.addEventListener('pointermove', event => {
          const drag = this.drag;
          if (!drag || drag.id !== event.pointerId) return;
          const dx = event.clientX - drag.x;
          const dy = event.clientY - drag.y;
          if (!drag.active) {
            if (Math.abs(dx) < 8) return;
            if (Math.abs(dy) > Math.abs(dx)) { this.drag = null; return; }
            drag.active = true;
            this.suppressClick = true;
            this.track.classList.add('is-dragging');
            this.track.setPointerCapture(event.pointerId);
          }
          event.preventDefault();
          this.track.scrollLeft = drag.left - dx;
        }, options);
        const finish = event => {
          if (!this.drag || this.drag.id !== event.pointerId) return;
          const active = this.drag.active;
          this.drag = null;
          if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
          this.track.classList.remove('is-dragging');
          if (active) {
            this.goTo(this.currentIndex());
            clearTimeout(this.clickTimer);
            this.clickTimer = setTimeout(() => { this.suppressClick = false; }, 0);
          }
        };
        this.track.addEventListener('pointerup', finish, options);
        this.track.addEventListener('pointercancel', finish, options);
        this.track.addEventListener('lostpointercapture', finish, options);
        this.track.addEventListener('pointerleave', event => {
          if (this.drag && !this.drag.active) this.drag = null;
        }, options);
        this.track.addEventListener('dragstart', event => {
          if (this.slider) event.preventDefault();
        }, options);
        this.track.addEventListener('click', event => {
          if (!this.suppressClick || event.detail === 0) return;
          event.preventDefault();
          event.stopImmediatePropagation();
        }, { ...options, capture: true });
        this.track.addEventListener('focusin', event => {
          if (!this.slider) return;
          const card = event.target.closest('.cs-home-blog__card');
          if (!card) return;
          const a = card.getBoundingClientRect();
          const b = this.track.getBoundingClientRect();
          if (a.left < b.left - 1 || a.right > b.right + 1) this.goTo([...this.track.children].indexOf(card));
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.cs-home-blog__card');
          if (card && this.slider) this.goTo([...this.track.children].indexOf(card));
        }, options);
        this.observer = new ResizeObserver(() => this.scheduleUpdate());
        this.observer.observe(this.track);
        this.update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        clearTimeout(this.clickTimer);
        this.track?.classList.remove('is-dragging');
        this.drag = null;
      }
      scheduleUpdate() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }
      get position() {
        return this.rtl ? -this.track.scrollLeft : this.track.scrollLeft;
      }
      get step() {
        const first = this.track.children[0];
        if (!first) return 1;
        return first.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 0);
      }
      currentIndex() {
        return Math.round(this.position / this.step);
      }
      goTo(index) {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const target = Math.min(max, Math.max(0, index * this.step));
        this.track.scrollTo({ left: this.rtl ? -target : target, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      move(direction) {
        this.goTo(this.currentIndex() + direction);
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const overflow = this.slider && max > 2;
        this.dataset.overflow = String(overflow);
        if (this.navigation) this.navigation.hidden = !overflow;
        if (this.previous) this.previous.disabled = !overflow || this.position <= 2;
        if (this.next) this.next.disabled = !overflow || this.position >= max - 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["crosight-riding-reward"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('crosight-riding-reward')) {
    customElements.define('crosight-riding-reward', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.layout = this.querySelector('.crr__layout');
        this.trigger = this.querySelector('.crr__trigger');
        this.panel = this.querySelector('.crr__panel');
        this.image = this.querySelector('.crr__image');
        this.dialog = this.querySelector('.crr__dialog');
        this.termsTrigger = this.querySelector('.crr__terms-trigger');
        if (this.image && !this.cover) this.cover = Object.fromEntries(['src', 'srcset', 'sizes', 'width', 'height', 'alt'].map(key => [key, this.image.getAttribute(key)]));
        this.trigger.addEventListener('click', () => this.toggle(), options);
        this.querySelectorAll('.crr__collapse').forEach(button => button.addEventListener('click', () => this.toggle(false), options));
        this.termsTrigger.addEventListener('click', () => {
          if (!this.dialog.open) this.dialog.showModal();
        }, options);
        this.querySelector('.crr__dialog-close').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          if (this.isConnected) this.termsTrigger.focus({ preventScroll: true });
        }, options);
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && !this.dialog.open && this.hasAttribute('data-expanded')) {
            this.toggle(false);
            this.trigger.focus({ preventScroll: true });
          }
        }, options);
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.animation?.cancel();
        if (this.dialog?.open) this.dialog.close();
      }
      setImage(opening) {
        if (!this.image || !this.trigger.dataset.detailSrc) return;
        if (opening) {
          const data = this.trigger.dataset;
          this.image.setAttribute('srcset', data.detailSrcset);
          this.image.setAttribute('src', data.detailSrc);
          this.image.setAttribute('sizes', '(min-width: 700px) 40vw, 100vw');
          this.image.setAttribute('width', data.detailWidth);
          this.image.setAttribute('height', data.detailHeight);
          this.image.setAttribute('alt', data.detailAlt);
        } else {
          Object.entries(this.cover).forEach(([key, value]) => {
            if (value === null) this.image.removeAttribute(key);
            else this.image.setAttribute(key, value);
          });
        }
      }
      toggle(force) {
        const opening = typeof force === 'boolean' ? force : !this.hasAttribute('data-expanded');
        const from = this.layout.getBoundingClientRect().height;
        this.animation?.cancel();
        this.toggleAttribute('data-expanded', opening);
        this.trigger.setAttribute('aria-expanded', String(opening));
        this.setImage(opening);
        this.panel.hidden = false;
        if (!opening && this.panel.contains(document.activeElement)) this.trigger.focus({ preventScroll: true });
        this.panel.inert = !opening;
        const to = opening ? this.layout.scrollHeight : this.trigger.getBoundingClientRect().height;
        const duration = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 320;
        const animation = this.layout.animate([{ height: from + 'px' }, { height: to + 'px' }], { duration, easing: 'ease-in-out', fill: 'both' });
        this.animation = animation;
        animation.finished.then(() => {
          if (this.animation !== animation) return;
          this.panel.hidden = !opening;
          animation.cancel();
          this.animation = null;
          if (!opening && this.isConnected) this.scrollIntoView({ behavior: duration ? 'smooth' : 'instant', block: 'start' });
        }).catch(() => {});
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!window.__crosightQuickAddCloseInstalled) {
    window.__crosightQuickAddCloseInstalled = true;
    document.addEventListener('click', function (event) {
      const closeButton = event.target.closest('[data-crosight-close-quick-add]');
      if (!closeButton) return;
      const bar = closeButton.closest('product-quick-add');
      if (!bar) return;
      event.preventDefault();
      event.stopPropagation();
      const section = bar.closest('.shopify-section');
      if (section) section.classList.add('crosight-quick-add-dismissed');
      else bar.hidden = true;
    });
  }

  } catch(e) { console.error(e); }
})();
})();
